//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

// TODO: PD-312036 - Remove feature flag check once CastaCrfPayment is released
export const getIsCastaCrfPaymentEnabled = createHasFeatureSelector(
  FeatureNames.CastaCrfPayment,
);
